import axios from 'axios'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
})

// JWT interceptor — attach token to every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Response interceptor — clear token on 401 and redirect to login
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const hadToken = !!localStorage.getItem('auth_token')
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
      // Redirect to login if user had a valid session (token expired mid-use)
      if (hadToken && !window.location.pathname.startsWith('/login') && window.location.pathname !== '/') {
        window.location.href = '/'
      }
    }
    return Promise.reject(error)
  }
)

export const api = {
  get: async (url, params = {}) => {
    const response = await apiClient.get(url, { params })
    return response.data
  },
  post: async (url, data = {}) => {
    const response = await apiClient.post(url, data)
    return response.data
  },
  put: async (url, data = {}) => {
    const response = await apiClient.put(url, data)
    return response.data
  },
  delete: async (url) => {
    const response = await apiClient.delete(url)
    return response.data
  },
}
